import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import axios from 'axios'
import AxiosPlugin from 'vue-axios-cors'
import JsonExcel from 'vue-json-excel'
import DisableAutocomplete from 'vue-disable-autocomplete'
import vuecookies from 'vue-cookies'
import vSelect from 'vue-select'
import VueTableDynamic from 'vue-table-dynamic'
import VTooltip from 'v-tooltip'
import VueLazyload from 'vue-lazyload'
import Select2 from 'v-select2-component'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import 'babel-polyfill'

// BSV Plugin Registration
Vue.directive("uppercase", {
  update: el => {
      el.value = el.value.toUpperCase()
    },
})
Vue.use(ToastPlugin)
Vue.use(router)
Vue.use(VTooltip)
Vue.use(ModalPlugin)
Vue.use(AxiosPlugin)
Vue.use(DisableAutocomplete)
Vue.use(VueLazyload)
Vue.use(VueTableDynamic)
Vue.component('Select2', Select2)
Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select-new', vSelect)
// Composition API
Vue.use(VueCompositionAPI)
Vue.use(vuecookies, { expire: '7d' })
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
